module.exports = __webpack_public_path__ + "static/media/recent-05.f9dfc16f.jpg";